import { getStaticPathsForLocales } from '../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { ResetPasswordPage } from '../../features/auth/reset-password/ui/ResetPasswordPage';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps = () => ({ props: {} });

export default ResetPasswordPage;
